import { render } from "./PaidTeachPage.vue?vue&type=template&id=db6b84d0&scoped=true"
import script from "./PaidTeachPage.vue?vue&type=script&lang=js"
export * from "./PaidTeachPage.vue?vue&type=script&lang=js"

import "./PaidTeachPage.vue?vue&type=style&index=0&id=db6b84d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6b84d0"]])

export default __exports__